import React, { useState, useEffect, useMemo } from 'react';
import { Button, ButtonGroup, Col, Row, Card } from 'react-bootstrap';
import { Header, Segment, Image, Dimmer, Loader, Icon } from 'semantic-ui-react';
import { Tooltip, Typography, message } from "antd";
import { store } from 'xijs';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import { Link, useHistory } from "react-router-dom";
import Amplify, { API, Auth } from 'aws-amplify';

function simulateNetworkRequest() {
    return new Promise((resolve) => setTimeout(resolve, 2000));
}

export default function ESP_Result() {

    const Bucket = "https://p450-result-prod.s3.amazonaws.com/";
    let history = useHistory();

    const [params, setParams] = useState([]);
    const [items, setItems] = useState([]);
    const [count, setCount] = useState(0);
    const [result, setResult] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [clicked, setClicked] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isLoaded1, setIsLoaded1] = useState(false);

    const [mark, setMark] = useState(0);

    const [isFinished, setIsFinished] = useState(true);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        if (isFinished === false) {
            const timer = setInterval(() => {
                history.go(0);
            }, 30000);
            return () => clearInterval(timer);
        }
    }, [isFinished]);

    useEffect(() => {
        if (clicked) {
            simulateNetworkRequest().then(() => {
                setClicked(false);
            });
        }
    }, [clicked]);

    useEffect(() => {
        let current = getAllIDs();
        // console.log(current);
        if (current.length !== 0) {
            setParams(current);
            setIsLoaded1(true);
        } else {
            setParams([]);
            setIsLoaded(true);
        }
    }, []);

    useEffect(() => {
        if (isLoaded1 === true) {
            getItems();
        }
    }, [isLoaded1])

    function getAllIDs() {
        var valueArr = [];
        var storage = window.localStorage
        // console.log("localStorage", storage);
        for (var i = 0; i < storage.length; i++) {
            var key = storage.key(i);
            // console.log("key",key);
            if (key.startsWith("xi-esp-")) {
                let current = store.get(key.replaceAll("xi-", ""));
                // console.log("current",current);
                if (current.status === 0) {
                    let currentItem = current.value;
                    valueArr.push(currentItem);
                }
            }

        }
        // console.log("valueArr",valueArr);
        return valueArr;
    }


    function handleDelete(e) {
        let current = e.target.value;
        // alert(current);
        localStorage.removeItem("xi-esp-" + current);

        window.location.href = "./esp-results";

    }

    async function getItems() {
        // Amplify.Logger.LOG_LEVEL = "DEBUG";
        // const current = props;
        // console.log("file name:",current);
        console.log(params);
        // const session = await Auth.currentCredentials();
        // console.log(session)
        const apiRequest = {
            body: {
                "ids": params,

            },
            headers: {
                "Content-Type": "application/json",
                // "Authorization":  session.getIdToken().getJwtToken()
            },
        };
        // console.log("API Request:getJwtToken",  session.getIdToken().getJwtToken());

        return await API
            .post("Substrate", "/api/result", apiRequest)
            .then(
                (data) => {
                    console.log(data);
                    if (data.code === 0) {

                        setItems(data.data);
                        setCount(data.data.length);
                        let currentIsFinished = getStatus(data.data);
                        setIsFinished(currentIsFinished);
                        setTimeout(() => {
                            setIsLoaded(true);
                            setIsLoaded1(true);
                        }, 500);
                    } else if (data.code === 1) {
                        // setIsLoaded1(true);
                        // setIsLoaded(true);
                        message.error({ content: 'ERROR: ' + data.msg, style: { marginTop: '40vh' } });
                    } else {
                        message.error({ content: 'ERROR: ' + data.errorMessage, style: { marginTop: '40vh' } });
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
    };

    function handleRefresh() {
        // setClicked(true);
        // setIsLoaded(false);
        // setIsLoaded1(false);
        // getResult();
        window.location = "/esp-results";

    }

    const useSortableData = (items, config = null) => {
        const [sortConfig, setSortConfig] = useState(config);

        const sortedItems = useMemo(() => {
            let sortableItems = [...items];
            if (sortConfig !== null) {
                sortableItems.sort((a, b) => {
                    if (a[sortConfig.key] < b[sortConfig.key]) {
                        return sortConfig.direction === "ascending" ? -1 : 1;
                    }
                    if (a[sortConfig.key] > b[sortConfig.key]) {
                        return sortConfig.direction === "ascending" ? 1 : -1;
                    }
                    return 0;
                });
            }
            return sortableItems;
        }, [items, sortConfig]);

        const requestSort = key => {
            let direction = "descending";
            if (
                sortConfig &&
                sortConfig.key === key &&
                sortConfig.direction === "descending"
            ) {
                direction = "ascending";
            }
            setSortConfig({ key, direction });
        };

        return { items: sortedItems, requestSort, sortConfig };
    };

    function getStatus(array) {
        for (let i = 0; i < array.length; i++) {
            if (array[i].status === "queue") {
                return false;
            }
        }

        return true;
    }

    function ProjectTable(props) {
        const { items, requestSort, sortConfig } = useSortableData(props.projects);

        setMark(1);
        useEffect(() => {
            requestSort("ID");
        }, [mark]);
        const getClassNamesFor = name => {
            if (!sortConfig) {
                return;
            }
            return sortConfig.key === name ? sortConfig.direction : undefined;
        };

        return (
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell
                                onClick={() => requestSort("jobid")}
                                className={getClassNamesFor("jobid")}
                                align="center"
                            >Job ID</TableCell>
                            <TableCell
                                onClick={() => requestSort("substrate")}
                                className={getClassNamesFor("substrate")}
                                align="center"
                            >Substrate</TableCell>
                            <TableCell>FASTA</TableCell>
                            <TableCell
                                onClick={() => requestSort("timestamp")}
                                className={getClassNamesFor("timestamp")}
                                align="center"
                            >Created</TableCell>
                            <TableCell
                                onClick={() => requestSort("status")}
                                className={getClassNamesFor("status")}
                                align="center"
                            >Status</TableCell>
                            <TableCell align="center">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            let current_disable = row.result === "" ? true : false;
                            // console.log(row.ID,current_disable);
                            return (
                                <TableRow key={row.jobid}>
                                    <TableCell align="center">
                                        {row.jobid}
                                    </TableCell>
                                    <TableCell align="center">{row.substrate.startsWith("s3://p450-result-prod") ? row.substrate.split("/")[row.fasta.split("/").length - 1] : row.substrate}</TableCell>
                                    <TableCell align="center">{row.fasta.split("/")[row.fasta.split("/").length - 1]}</TableCell>
                                    <TableCell align="center">{new Date(Number(row.timestamp) * 1000).toLocaleString()}</TableCell>
                                    <TableCell align="center">{row.status}</TableCell>

                                    <TableCell align="center">
                                        <ButtonGroup>
                                            {
                                                row.error === ""
                                                    ?
                                                    <Button value={row.jobid} variant="success" disabled={current_disable} onClick={() => window.open("/esp-detail/" + row.jobid)}>Result</Button>
                                                    :
                                                    <Tooltip title={row.jobid}>
                                                        <Button value={row.jobid} variant="warning">Error Log</Button>
                                                    </Tooltip>

                                            }
                                            <Button value={row.jobid} variant="danger" onClick={handleDelete}>Delete</Button>
                                        </ButtonGroup>
                                    </TableCell>
                                </TableRow>

                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }

    return (
        <div style={{
            background: "#FFFFFF"

        }}>

            <Row>
                <Col >
                </Col>
                <Col md={10}>

                    <div style={{

                        height: "50px"
                    }}>
                    </div>
                    <div>


                        <Card>
                            <Card.Header>
                                <Header textAlign='center'>
                                    <span style={{ color: "#6495ED" }} >Enzyme-Substrate Interaction Predictor Results</span>
                                </Header>
                            </Card.Header>
                            <Card.Body>
                                <div style={{ margin: "25px 75px 25px 75px" }}>
                                    <Typography.Paragraph italic style={{ textAlign: "justify" }}><blockquote>Users can submit a substrate molecule (in SDF format) along with one or more P450 sequences. We will use a deep learning model (Seq-P450: <Typography.Link href='https://github.com/JiangLab2020/Seq-P450' target='_blank' rel='noopener noreferrer'>https://github.com/JiangLab2020/Seq-P450</Typography.Link>) to predict the likelihood that these P450 enzymes can catalyze the submitted substrate molecule.</blockquote></Typography.Paragraph>
                                </div>
                                <Segment basic >
                                    {
                                        isLoaded
                                            ?
                                            <ProjectTable projects={items} />
                                            :
                                            <Segment>
                                                <Dimmer active inverted>
                                                    <Loader size='medium'>Loading</Loader>
                                                </Dimmer>

                                                <Image src='../paragraph.png' />
                                            </Segment>
                                    }

                                    <Row>
                                        <Col md={6}>
                                            <ButtonGroup aria-label="Basic example">
                                                <Button
                                                    variant="outline-secondary"
                                                    disabled={clicked}
                                                    onClick={!clicked ? handleRefresh : null}
                                                >
                                                    {
                                                        clicked
                                                            ?
                                                            <Icon loading name='redo' />
                                                            :
                                                            <Icon name='redo' />
                                                    }

                                                </Button>
                                                <Button variant="outline-secondary" href="/esp">Back</Button>
                                            </ButtonGroup>

                                        </Col>
                                        <Col md={6}>
                                            <TablePagination
                                                component="div"
                                                count={count}
                                                page={page}
                                                onChangePage={handleChangePage}
                                                rowsPerPage={rowsPerPage}
                                                onChangeRowsPerPage={handleChangeRowsPerPage}
                                            />
                                        </Col>
                                    </Row>
                                </Segment>


                            </Card.Body>
                        </Card>


                    </div>


                    <div>


                        <div>

                        </div>



                    </div>
                    <div style={{

                        height: "50px"
                    }}>
                    </div>
                </Col>
                <Col >
                </Col>
            </Row>
        </div>

    );
}